import myzxios from '../utils/myaxios'

export function getFunc(data){
    return myzxios({
        url: '/manager/account/getFunctionList/'+data,
        method: 'GET'
    })
}

export function startFuncAuth(data){
    return myzxios({
        url: '/manager/function/startAuth',
        params: data,
        method: 'GET'
    })
}

export function loadTree(){
    return myzxios({
        url: '/manager/function/load-tree/',
        method: 'GET'
    })
}

export function queryDzFunction(data){
    return myzxios({
        url: '/manager/function/queryDzFunction',
        params: data,
        method: 'GET'
    })
}